import { render, staticRenderFns } from "./IndividualEmployeeAwayEntitlementTable.vue?vue&type=template&id=181c27aa&scoped=true&"
import script from "./IndividualEmployeeAwayEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./IndividualEmployeeAwayEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c27aa",
  null
  
)

export default component.exports